<template>
  <div class="code-paiement">

    <div class="neph-banner" v-if="!$store.state.numNeph">
      <div class="neph-banner__icon">
        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="#b45309" stroke-width="1.5"/><path d="M12 8v4M12 16h.01" stroke="#b45309" stroke-width="2" stroke-linecap="round"/></svg>
      </div>
      <p class="neph-banner__text">
        Vous pouvez vous préparer au code. Pour information, vous n'avez pas encore obtenu votre numéro NEPH, nécessaire pour le passage des examens de code et de conduite.
        RDV dans <span class="neph-banner__link" @click="goToDossier">DOSSIER</span> pour suivre l'avancement et éventuellement déposer des pièces manquantes.
      </p>
    </div>

    <div class="page-header">
      <div class="page-header-left">
        <h1><span @click="goToHome">Accueil</span> > Code</h1>
      </div>
    </div>

    <div class="two-col">
      <!-- ---- LEFT: paiement ---- -->
      <div class="left-col">
        <!-- Inclus dans la formule -->
        <div class="section-card">
          <div class="section-card-header">
            <div class="section-card-icon icon-green">
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path d="M20 7H4a2 2 0 00-2 2v8a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z" stroke="#1a9e6e" stroke-width="1.5" />
                <path d="M16 3H8M12 3v4" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div style="display:flex; align-items:center; height:100%;">
              <div class="section-num" style="font-weight:800; margin:0; color:#1a1f2e; font-size:16px; letter-spacing:0;">Fonctionnement Code</div>
            </div>
          </div>
          <div class="section-card-body">
            <p class="section-intro">
              Nous vous mettons à disposition les outils qui vous permettront de réussir votre examen de code
            </p>

            <div class="feature-list">
              <div class="feature-item feature-item--green">
                <div class="feature-item-icon">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                    <rect x="4" y="2" width="16" height="20" rx="2" stroke="#1a9e6e" stroke-width="1.5" />
                    <path d="M8 7h8M8 11h8M8 15h5" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </div>
                <div>
                  <div class="feature-item-title">Un livre de code</div>
                  <div class="feature-item-sub feature-item-sub--green">Inclus dans votre formation</div>
                </div>
                <svg class="feature-item-check" width="16" height="16" fill="none" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4" stroke="#1a9e6e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>

              <div class="feature-item feature-item--blue">
                <div class="feature-item-icon">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="9" stroke="#3b82f6" stroke-width="1.5" />
                    <path d="M12 8v4M12 16h.01" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </div>
                <div>
                  <div class="feature-item-title">Un Prépacode</div>
                  <div class="feature-item-sub feature-item-sub--blue">Des centaines de questions corrigées sur prepacode-enpc.fr</div>
                </div>
                <svg class="feature-item-check" width="16" height="16" fill="none" viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4" stroke="#3b82f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Modes de paiement -->
        <div class="section-card section-card--clickable" @click="goToPaiement('cb')">
          <div class="section-card-header">
            <div class="section-card-icon icon-amber">
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="#f59e0b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div>
              <div class="section-num">Étape suivante</div>
              <div class="section-title">Paiement Code</div>
            </div>
          </div>
            <!-- Montant -->
            <div class="montant-box">
              <div>
                <div class="montant-label">Montant à régler</div>
                <div>{{ filterFonctionnalite.montant }} <span>€</span></div>
              </div>
            </div>
          <div class="section-card-body" @click.stop>
            <BoutonPaiement @paiement="goToPaiement($event)"></BoutonPaiement>
          </div>
        </div>
      </div>

      <!-- ---- RIGHT: méthode ---- -->
      <div class="method-panel">
        <h2>La Bonne méthode</h2>

        <div class="method-step">
          <div class="method-step-title">
            <span class="method-step-num">I</span>
            D'abord travailler les thèmes
          </div>
          <div class="method-sub">
            <div class="method-sub-item">Livre de code : lire le 1er thème</div>
            <div class="method-sub-item">Prépacode : faire les tests du 1er thème</div>
            <div class="method-sub-item">Faire de même pour chaque thème</div>
          </div>
        </div>

        <div class="method-sep"></div>

        <div class="method-step">
          <div class="method-step-title">
            <span class="method-step-num">II</span>
            Ensuite travailler les séries d'entraînement
          </div>
          <div class="method-sub">
            <div class="method-sub-item">Faire plusieurs séries d'entraînement</div>
            <div class="method-sub-item">Vérifier votre niveau par thème et relire les thèmes avec un mauvais score</div>
            <div class="method-sub-item">À la fin de chaque session, reporter votre score (/40) dans le champ prévu</div>
          </div>
        </div>

        <div class="method-sep"></div>

        <div class="method-step method-step--last">
          <div class="method-step-title">
            <span class="method-step-num">III</span>
            Enfin, travailler les examens blancs
          </div>
        </div>

        <div class="method-tip">
          IV) Vous avez au moins 35/40 de manière régulière ? → Réservez votre place d'examen
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoutonPaiement from "@/components/eleve/BoutonPaiement.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BoutonPaiement,
  },

  mounted() {
    this.getFonctionnalite();
    this.fetchNumNeph();
  },

  methods: {

    ...mapActions(["getFonctionnalite"]),

    goToPaiement(mode) {
      this.$store.dispatch("startSaveBouton", mode);
      let fonctionnalite = "code";
      let router = this.$router;
      this.$store.dispatch("endSaveBouton", { mode, fonctionnalite, router });
    },

    fetchNumNeph() {
      window.api
        .get("/eleve/home/info/" + this.$store.state.user.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.$store.commit("setNumNeph", response.data.info.dossier.neph ?? null);
        })
        .catch(() => {});
    },

    goToHome() {
      this.$router.push({ name: "Home" });
    },

    goToDossier() {
      window.api
        .get("/student/" + this.$store.state.user.id + "/paiement/dossier", {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          if (!response.data.paid) {
            this.$router.push({ name: "Dossier-paiement" });
          } else {
            this.$router.push({ name: "Piece" });
          }
        })
        .catch(() => {
          this.$router.push({ name: "Piece" });
        });
    },

  },

  computed: {
    ...mapGetters(["fonctionnalite"]),
    filterFonctionnalite() {
      if (this.fonctionnalite !== null) {
        return this.fonctionnalite.filter((el) => el.label === "code")[0];
      }
      return "";
    },

  },

};
</script>

<style scoped>

/* ===== Bandeau NEPH manquant ===== */
.neph-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fffbeb;
  border: 1.5px solid #fcd34d;
  border-radius: 12px;
  padding: 14px 18px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.neph-banner__icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.neph-banner__text {
  font-size: 14px;
  color: #92400e;
  line-height: 1.55;
  margin: 0 !important;
}

.neph-banner__link {
  font-weight: 700;
  color: #b45309;
  text-decoration: underline;
  cursor: pointer;
}
.neph-banner__link:hover {
  color: #92400e;
}

div.code-paiement {
  width: 60%;
  margin: auto;
}

/* ===================== PAGE HEADER ===================== */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
  margin-top: 20px;
  gap: 24px;
}

.page-header-left h1 {
  font-size: 30px;
  color: #1a1f2e;
  letter-spacing: -0.5px;
  margin-bottom: 4px;
  font-weight: bold;
}

.page-header-left h1 span:hover{
  color: #5F626E;
  cursor: pointer;
}

.page-header-left p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  text-align: left;
}

/* ===================== TWO-COL LAYOUT ===================== */
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

/* ===================== LEFT COL ===================== */
.left-col {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ===================== SECTION CARDS ===================== */
.section-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: box-shadow 0.2s;
}
.section-card:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
}
.section-card--clickable {
  cursor: pointer;
}

.section-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-card-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-green { background: #e8f7f1; }
.icon-amber { background: #fef3c7; }

.section-num {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 1px;
  text-align: left;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a1f2e;
  text-align: left;
}

.section-card-body {
  padding: 24px;
}

/* ===================== SECTION INTRO ===================== */
.section-intro {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 18px;
  text-align: left;
}

/* ===================== FEATURE LIST ===================== */
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 22px;
  text-align: left;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
}
.feature-item--green { background: #e8f7f1; }
.feature-item--blue  { background: #eff6ff; }

.feature-item-icon {
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.feature-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a1f2e;
}

.feature-item-sub {
  font-size: 11px;
}
.feature-item-sub--green { color: #065f46; }
.feature-item-sub--blue  { color: #1d4ed8; }

.feature-item-check {
  margin-left: auto;
  flex-shrink: 0;
}

/* ===================== MONTANT ===================== */
.montant-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  background: #f4f6f9;
  width: 80%;
  margin: auto;
  margin-top: 1rem;
}

.montant-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 3px;
}

.montant-right {
  text-align: right;
}

.montant-info {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

/* ===================== METHOD PANEL ===================== */
.method-panel {
  background: linear-gradient(135deg, #ff6b9d 0%, #ff9a3c 50%, #ffd166 100%);
  border-radius: 16px;
  padding: 32px 28px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.method-panel::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -60px;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}

.method-panel::after {
  content: "";
  position: absolute;
  bottom: -80px;
  left: -40px;
  width: 250px;
  height: 250px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.method-panel h2 {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 24px;
  opacity: 0.97;
  position: relative;
  z-index: 1;
}

.method-step {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.method-step--last {
  margin-bottom: 0;
}

.method-step-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 6px;
  opacity: 0.95;
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-step-num {
  width: 22px;
  height: 22px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.method-sub {
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.method-sub-item {
  font-size: 12px;
  opacity: 0.85;
  padding: 3px 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  text-align: left;
}

.method-sub-item::before {
  content: "→";
  opacity: 0.6;
  flex-shrink: 0;
  margin-top: 1px;
}

.method-tip {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.95;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}

.method-sep {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 14px 0;
  position: relative;
  z-index: 1;
}

/* ===================== PAYMENT OPTIONS ===================== */
.pay-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: #f4f6f9;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.18s;
  text-align: left;
}
.pay-option:hover {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.08);
  transform: translateY(-1px);
}
.pay-option--selected {
  border-color: #3b82f6;
  background: #eff6ff;
}
.pay-option--selected .pay-option-check {
  opacity: 1;
  background: #3b82f6;
  color: #fff;
}

.pay-option-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pay-option-text {
  flex: 1;
  min-width: 0;
}
.pay-option-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a1f2e;
  margin-bottom: 2px;
}
.pay-option-sub {
  font-size: 11px;
  color: #64748b;
}

.pay-option-check {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  opacity: 0;
  transition: all 0.15s;
  color: #94a3b8;
}

.btn-pay {
  padding: 13px 24px;
  background: linear-gradient(135deg, #1a9e6e, #0d7a54);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.18s;
  letter-spacing: 0.02em;
  box-shadow: 0 4px 16px rgba(26, 158, 110, 0.25);
}
.btn-pay:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(26, 158, 110, 0.3);
}

@media (max-width: 1100px) {
  .two-col {
    grid-template-columns: 1fr;
  }
  main {
    padding: 32px 20px;
  }
}
</style>